import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import appStore from '@/store/app';
import erpStore from '@/store/erp';
import { ErpOrder, ErpOrderLine, SelectItem } from '@/types';
import CardComponent from '@/components/CardComponent';
import CustomToolbar from '@/components/CustomToolbar';

@Component({
    components: { CardComponent, CustomToolbar },
})
export default class ErpOrderLines extends Vue {

    // Injectectd from url
    @Prop({ default: 0 }) private readonly day!: number;
    @Prop({ default: 0 }) private readonly month!: number;
    @Prop({ default: 0 }) private readonly year!: number;
    @Prop({ default: 0 }) private readonly id!: number;

    private selected: ErpOrder | null = null;
    private pageSize = appStore.pageSize;
    private pageNumber = 1;
    private viewType = 'B';

    get loading(): boolean {
        return appStore.isLoading;
    }

    get order(): ErpOrder {
        const orders = erpStore.orders.filter((o) => o.documentNumber === this.id);
        if (orders && orders.length > 0) {
            return orders[0];
        }
        return {} as ErpOrder;
    }

    get orderLines(): ErpOrderLine[] {
        return erpStore.orderLines;
    }

    get total(): number {
        return erpStore.totalOrderLines;
    }

    private async created() {
        await this.fetchOrderLinesAsync();
    }

    private async mounted() {
        await appStore.activateMenuById({ rootId: 300, subMenuId: 301 });
    }

    get filters(): SelectItem<string>[] {
        const result: SelectItem<string>[] = [];
        result.push({ value: 'B', description: 'Bollettino'} as SelectItem<string>);
        result.push({ value: 'F', description: 'Fattura'} as SelectItem<string>);
        result.push({ value: 'R', description: 'Ripresa'} as SelectItem<string>);
        return result;
    }

    @Watch('viewType', { immediate: false, deep: false })
    private async onViewFilterChanged(value: string, previousValue?: string) {
        if (previousValue === undefined) return;
        await this.fetchOrderLinesAsync();
    }

    private async refresh() {
        await this.fetchOrderLinesAsync();
    }

    private back() {
        this.$router.go(-1);
    }

    private select(row: ErpOrder, oldRow: ErpOrder | null): void {
        this.selected = row;
    }

    private async fetchOrderLinesAsync() {
        await erpStore.fetchOrderLinesAsync({ day: this.day, month: this.month, year: this.year, documentNumber: this.id, orderBy: this.viewType  });
    }

    private rowStyle(orderLine: ErpOrderLine, index: number) {
        if (orderLine && orderLine.lineType === 'N') {
            return 'is-warning';
        }
    }
}